﻿export default function getBadRequestErrorsOrThrow(error: unknown) {
    if (!isNuxtError(error)) throw error;

    if (error.status !== 400) throw error;

    return getAllErrorMessages(error);
}
